import React, { useState, useEffect } from "react";

import { withSnackbar } from "notistack";
import { LABELS } from "common/lables";
import { Marker } from "react-leaflet";
import { GEO_APIs } from "apihandlers/geography";

const states = require("./states.json");

const MapDrillDown = (props: any) => {
  const { getMapMarker, showDrilldown, updateLocation } = props;

  const [drilldown, setDrilldown] = useState<boolean>(false);
  const [stateDistrict, setStateDistrict] = useState<boolean>(true);
  const [district, setDistrict] = useState<any>(null);
  const [showDistrict, setShowDistrict] = useState<boolean>(false);
  const [showStates, setShowStates] = useState<boolean>(false);
  const [showTaluk, setShowTaluk] = useState<boolean>(false);
  const [taluk, setTaluk] = useState<any>(null);

  useEffect(() => {
    if (showDrilldown) {
      manageDrilldown();
    }
  }, [showDrilldown]);

  const getDistricts = async (s) => {
    const lat = s.lat;
    const lng = s.lng;
    updateLocation({ lat, lng }, 8);
    try {
      const args = {
        district: s.state,
      };
      const res: any = await GEO_APIs.getDistrictsDrilldown(args);
      const { status, response } = res;
      if (status === 200) {
        let district = response;
        setDistrict(district);
      }
      setShowDistrict(true);
      setStateDistrict(true);
      setShowStates(false);
    } catch (error) {
      console.error("getDistrict:", error);
    }
  };

  const getTaluks = async (d) => {
    const lat = d.lat;
    const lng = d.lng;
    updateLocation({ lat, lng }, 11);
    try {
      const args = {
        taluk: d.district,
      };
      const res: any = await GEO_APIs.getTalukDrilldown(args);
      const { status, response } = res;
      if (status === 200) {
        let taluk = response;
        setTaluk(taluk);
      }
      setShowTaluk(true);
      setStateDistrict(false);
    } catch (error) {
      console.error("getTaluk:", error);
    }
  };

  const manageDrilldown = () => {
    setDrilldown(showDrilldown);
    setShowStates(true);
    setShowDistrict(false);
    setShowTaluk(false);
  };

  const stateLatLng = states.allStates;

  const getDistrictPage = () => {
    setShowStates(false);
    setShowTaluk(false);
    setStateDistrict(true);
  };

  const getStatePage = () => {
    // updateLocation({ lat, lng }, 11);
    setShowStates(true);
    setShowTaluk(false);
    setShowDistrict(false);
  };

  console.log("showDrilldown", showDrilldown);
  return (
    <>
      {showDrilldown && (
        <>
          {drilldown && (
            <div className="drilldownInfo">
              <ul className="breadcrumbs">
                <li onClick={() => getStatePage()}>
                  {drilldown ? LABELS.STATE : ""}
                </li>

                <li className="dimm"> {showDistrict ? " / " : ""}</li>
                <li onClick={() => getDistrictPage()}>
                  {showDistrict ? LABELS.DISTRICT : ""}
                </li>
                <li className="dimm">{showTaluk ? " / " : ""}</li>
                <li className="active">{showTaluk ? LABELS.AREA : ""}</li>
              </ul>
            </div>
          )}
          {showStates &&
            drilldown &&
            stateLatLng.map((states, i) => {
              return (
                <Marker
                  position={{
                    lat: states.lat,
                    lng: states.lng,
                  }}
                  icon={getMapMarker(1)}
                  key={"statesOnMap-" + i}
                  className="mapMarker"
                  onClick={() => {
                    getDistricts(states);
                  }}
                >
                  {/* <Tooltip
                direction="right"
                offset={[10, -2]}
                className={"makerLabel"}
                permanent
              >
                <span>{states.state}</span>
              </Tooltip> */}
                </Marker>
              );
            })}
          {showDistrict &&
            drilldown &&
            district &&
            stateDistrict &&
            district.map((d, i) => {
              return (
                <Marker
                  position={{
                    lat: d.lat,
                    lng: d.lng,
                  }}
                  icon={getMapMarker(2)}
                  key={"districtOnMap-" + i}
                  className="mapMarker"
                  onClick={() => {
                    getTaluks(d);
                  }}
                >
                  {/* <Tooltip
                direction="right"
                offset={[10, -2]}
                className={"makerLabel"}
                permanent
              >
                <span>{d.district}</span>
              </Tooltip> */}
                </Marker>
              );
            })}
          {showTaluk &&
            drilldown &&
            taluk &&
            taluk.map((t, i) => {
              return (
                <Marker
                  position={{
                    lat: t.lat,
                    lng: t.lng,
                  }}
                  icon={getMapMarker(1)}
                  key={"talukOnMap-" + i}
                  className="mapMarker"
                  //   onClick={() => {
                  //     getArea(t);
                  //   }}
                >
                  {/* <Tooltip
                direction="right"
                offset={[10, -2]}
                className={"makerLabel"}
                permanent
              >
                <span>{t.name}</span>
              </Tooltip> */}
                </Marker>
              );
            })}
        </>
      )}
    </>
  );
};
export default withSnackbar(MapDrillDown);
